import React, { useCallback } from 'react';
import { Button } from 'reactstrap';
import { Icon } from 'js/components';

import { faLinkSlash } from '@fortawesome/pro-regular-svg-icons';

import styles from './ProductManagerList.module.scss';
import { faHeadSideGear } from '@fortawesome/pro-solid-svg-icons';

function ProductManagerCard({ productManager, onRemoveProductManager }) {
  const handleRemoveProductManager = useCallback(() => {
    onRemoveProductManager(productManager);
  }, [productManager, onRemoveProductManager]);

  return (
    <div className={styles['product-manager-item']}>
      <div className={styles['avatar']}>
        <div className={styles['avatar-image']}>
          <Icon icon={faHeadSideGear} />
        </div>
      </div>
      <div className={styles['product-manager-content']}>
        <div className={styles['product-manager-name']}>
          {productManager.name}
        </div>
        <div className={styles['member-actions']}>
          <Button
            color="info"
            className="btn-inline"
            onClick={handleRemoveProductManager}
            title="Unlink"
            outline
          >
            <Icon icon={faLinkSlash} />
          </Button>
        </div>
      </div>
    </div>
  );
}

export default ProductManagerCard;
